package com.cybersoftsolution.cybersoftsolutionweb.use_cases

import com.cybersoftsolution.cybersoftsolutionweb.api.getPost
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.components.toast.showMyToast
import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.PostsUI
import com.cybersoftsolution.cybersoftsolutionweb.models.ui.ToastMessage
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.toastBasicID
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay


suspend fun CoroutineScope.getSimplePostsUseCase(
    state: PostsUI,
    setState: (PostsUI) -> Unit,
    setSearching: (Boolean) -> Unit,
    text: String,
    category: String?,
    requestPage: Int?,
    limit: Int?
){
    val scope = this

    setSearching(true)

    getPost(
        text = text,
        category =try { Category.valueOf(category?:"") } catch (e:Exception) {null} ,
        limit = limit,
        requestPage = requestPage
    ).also { response ->


//        delay(1000)

        console.log(response)



        if (text.isNotEmpty()) {
            if (response!=null && !response.message.isNullOrEmpty() && !response.data?.list.isNullOrEmpty())  {
                setState(
                    state.copy(
                        page = response.data,
                        toastMessage = ToastMessage(
                            message = response.message,
                            style = MyToastStyle.Success
                        )
                    )
                ).also {
                    scope.showMyToast(toastBasicID)
                }

            } else {
                setState(
                    state.copy(
                        page = response?.data,
                        toastMessage = ToastMessage(
                            message = response?.message?:"Error al obtener los datos",
                            style = MyToastStyle.Danger
                        )
                    )
                ).also {
                    scope.showMyToast(toastBasicID)
                }
            }
        } else {
            setState(
                state.copy(
                    page = response?.data,
                )
            )
        }


        setSearching(false)


    }
}